import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { IconButton } from "@mui/material";

type Props = {
	handleNew: () => void;
	disabled?: boolean;
	id?: string;
};

export const CustomStatusPanel = ({
	handleNew,
	disabled = false,
	id,
}: Props) => (
	<IconButton
		data-test-id={id}
		onClick={handleNew}
		color="primary"
		disabled={disabled}
		style={{ marginLeft: -15 }}
	>
		<PlaylistAddIcon style={{ width: 30, height: 30 }} />
	</IconButton>
);
